import { applicationGroupApi } from '../../api/applicationGroupApi'

import { applicationGroupsSignal, applicationGroupsLoadedSignal, applicationGroupsErrorSignal } from '../signals/applicationGroupSignals'
import { notifyException } from './notificationActions'

export const fetchApplicationGroups = async (config, accessToken) => {
    applicationGroupsLoadedSignal.value = false
    applicationGroupsSignal.value = []
    return await applicationGroupApi.fetchApplicationGroups(config, accessToken).then(
        (appGroups) => {
            applicationGroupsErrorSignal.value = null
            applicationGroupsSignal.value = appGroups
            applicationGroupsLoadedSignal.value = true
            return appGroups
        }
    ).catch(
        (error) => {
            applicationGroupsErrorSignal.value = error
            notifyException(error, "Error fetching application groups")
        }
    )
}